// Keep the blog editor's formatting without permitting executable markup.
export function safeBlogHtml(html) {
  const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
  const allowed = new Set(['P', 'BR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'UL', 'OL', 'LI', 'BLOCKQUOTE', 'PRE', 'CODE', 'HR', 'A', 'IMG', 'SPAN', 'DIV']);
  for (const element of [...doc.body.querySelectorAll('*')]) {
    if (!allowed.has(element.tagName)) { element.remove(); continue; }
    for (const attr of [...element.attributes]) {
      if (!['href', 'src', 'alt', 'title', 'style', 'data-align', 'data-list-style', 'data-link-href', 'target', 'start'].includes(attr.name)) element.removeAttribute(attr.name);
    }
    for (const attr of ['href', 'src', 'data-link-href']) {
      const value = element.getAttribute(attr);
      const allowedUrl = /^(https?:\/\/|\/[^/]|#|mailto:)/i.test(value?.trim() || '');
      const imageData = attr === 'src' && /^data:image\/(png|jpeg|gif|webp);base64,[a-z0-9+/=\s]+$/i.test(value || '');
      if (value && !allowedUrl && !imageData) element.removeAttribute(attr);
    }
    if (element.hasAttribute('target') && !['_blank', '_self'].includes(element.getAttribute('target'))) element.removeAttribute('target');
    const styles = {};
    for (const key of ['textAlign', 'display', 'maxWidth', 'width', 'height', 'margin', 'listStyleType']) {
      const value = element.style[key];
      if (value && !/url|expression|@|\\/i.test(value)) styles[key] = value;
    }
    element.removeAttribute('style');
    Object.assign(element.style, styles);
    if (element.tagName === 'IMG') { element.style.maxWidth = '100%'; element.style.height = 'auto'; }
    if (element.tagName === 'A') element.setAttribute('rel', 'noopener noreferrer');
  }
  return doc.body.innerHTML;
}
